<script>
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import i18nMixin from '@/mixins/i18n.mixin.js';
import {h, resolveComponent} from "vue";
import {cLayout} from "@/components/cmp";

export default {
  name: 'widgetNotice',
  mixins: [i18nMixin],
  components: {widgetWrapper},
  emits: ['more', 'click'],
  render() {
    const {$theme, items} = this;
    const {title, subtitle, dateItem, lists, more, info} = items;
    const cLabel = resolveComponent('c-label')
    const legoIcon = resolveComponent('lego-icon')
    const widgetWrapper = resolveComponent('widget-wrapper')

    const nullList = h('div', {class: 'widget-null'}, [
      h(legoIcon, {
        iconType: 'df',
        icon: 'exclamation_circle',
        size: 72,
        color: '#D6DCF4',
      }),
      h(
          cLabel,
          {
            size: 20,
            weight: 500,
          },
          () => [this.t('label.noData')],
      ),
    ]);

    const widgetList =
        lists.length > 0
            ? lists.map((list, idx) => {
              return h(
                  'div',
                  {
                    class: 'widget-notice-list',
                    key: idx,
                  },
                  [
                    h('div', {class: 'widget-notice-list__name'}, [
                      h(
                          cLabel,
                          {
                            pointer: true,
                            ellipsis: true,
                            color: $theme.COLOR.UI.UI01,
                            width: 'auto',
                            size: 16,
                            onClick: () => {
                              this.onClick(list);
                            },
                          },
                          () => [list.name],
                      ),
                      list.new &&
                      h(legoIcon, {
                        iconType: 'df', icon: 'new', size: 16,
                        class: 'new-icon',
                      }),
                    ]),
                    h('div', {class: 'widget-notice-list__date'}, [
                      h(cLabel, {size: 16, color: $theme.COLOR.UI.UI01}, () => [list.date]),
                    ]),
                  ],
              );
            })
            : nullList;

    const widgetNotice = h('div', {class: 'widget-notice'}, [widgetList]);

    return h(
        widgetWrapper,
        {
          title, subtitle, dateItem, more, info,
          onMore: more => {
            this.$emit('more', more);
          },
        },
        () => [widgetNotice],
    );
  },
  methods: {
    onClick(list) {
      //console.log('click');
      this.$emit('click', list);
    },
  },
  props: {
    items: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.widget-notice {
  height: 100%;
  margin: 0 auto;
  padding: 29px 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;

  .widget-null {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center;
    height: 100%;

    :deep.lego-icon {
      margin-bottom: 17px;
    }
  }

  &-list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 17px;

    &:hover {
      .widget-notice-list__name .c-label {
        color: $color--primary !important;
      }
    }

    &:active {
      .widget-notice-list__name .c-label {
        color: $color--primary !important;
      }
    }

    &:nth-of-type(1) {
      margin-top: 0;
    }

    &__name {
      display: flex;
      flex: 1 1 auto;
      min-width: 0;

      &:before {
        content: '·';
        display: inline;
        margin-right: 4px;
        font-size: 16px;
      }
    }

    &__date {
      white-space: nowrap;
      margin-left: 10px;
    }

    :deep .new-icon {
      margin: 0 10px 0 5px;
    }
  }
}
</style>
